export default __webpack_public_path__ + "static/media/logo.e20dbe65.png";